import React, { useState } from 'react'
import Overlay from 'react-bootstrap/Overlay'
import Tooltip from 'react-bootstrap/Tooltip'

export const CustomTooltip = React.forwardRef((props, ref) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const targetElement = ref ? ref.current : props.children.ref?.current
  const getAdjustedPlacement = () => {
    if (!targetElement) return props.position
    const boundingRect = targetElement.getBoundingClientRect()
    const { innerWidth, innerHeight } = window
    const buffer = 150
    if (boundingRect.top < 40) {
      return 'bottom'
    } else if (boundingRect.bottom > innerHeight - buffer) {
      return 'top'
    } else if (boundingRect.left < buffer && props.position) {
      return 'right'
    } else if (boundingRect.right > innerWidth - buffer) {
      return 'left'
    }

    return props.position
  }
  return (
    <span
      ref={ref && ref}
      className={props.className}
      onMouseOver={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {props.children}
      <Overlay
        target={targetElement}
        show={showTooltip}
        placement={getAdjustedPlacement()}
        rootClose
        onHide={() => setShowTooltip(false)}
      >
        {overlayProps => (
          <Tooltip
            onMouseOver={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            id="overlay-example"
            {...overlayProps}
          >
            {props.text}
          </Tooltip>
        )}
      </Overlay>
    </span>
  )
})

CustomTooltip.displayName = 'CustomTooltip'
